module.exports = __webpack_public_path__ + "static/analytics-2-899d4e1eb31c6b9445caa0784d09dc4b.png";